import { webApiBuildUrl } from '@api/utils'

/**
 * api cities url
 */
export function allCitiesUrl(): string

/**
 * api cities url
 */
export function allCitiesUrl() {
    return webApiBuildUrl('api/company/cities')
}
